import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Motion";
import { IMAGES } from "@/data/content";

const CHAPTERS = [
  { n: "01", title: "Italian Soul", text: "Handmade pasta, wood-fired pizzas, and the slow ritual of the Italian table." },
  { n: "02", title: "Indian Heart", text: "Overnight-simmered dals, tandoor smoke, and spices layered with patience." },
  { n: "03", title: "L'Ospitalità", text: "Good food, good coffee, good company — served the Indian way: generously." },
];

const StoryTeaser = () => (
  <section id="story" className="bg-wine text-cream" data-testid="story-section">
    <div className="grid lg:grid-cols-2 min-h-[80vh]">
      <div className="relative h-[55vh] lg:h-auto overflow-hidden group">
        <img
          src={IMAGES.story}
          alt="Copper handis of slow-cooked curries at Forco Amore"
          loading="lazy"
          className="img-lux absolute inset-0 h-full w-full object-cover"
          data-testid="story-image"
        />
        <div className="absolute inset-0 bg-wine/20" />
      </div>

      <div className="flex items-center p-10 sm:p-16 lg:p-24 xl:p-32">
        <div>
          <Reveal>
            <Overline className="text-brass">Our Story</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight mt-5">
              Two Culinary Hearts, <span className="italic text-brass">One Table</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-cream/80 text-base md:text-lg font-light leading-relaxed max-w-xl">
              Forco Amore was born from a love affair between two great food cultures — the romance
              of Italy and the warmth of India. Good food, good coffee, good company: nothing more,
              nothing less.
            </p>
          </Reveal>

          <div className="mt-12 space-y-8">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={0.25 + i * 0.12}>
                <div className="flex gap-6 items-start" data-testid={`story-chapter-${i}`}>
                  <span className="font-serif italic text-brass/80 text-lg pt-1">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-medium tracking-tight">{c.title}</h3>
                    <p className="mt-1 text-cream/70 text-sm font-light leading-relaxed max-w-md">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.6}>
            <Link
              to="/story"
              data-testid="discover-story-btn"
              className="mt-12 inline-block rounded-full border border-cream/40 px-9 py-4 text-sm tracking-[0.14em] uppercase hover:bg-cream hover:text-wine transition-colors duration-300"
            >
              Discover Our Story
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default StoryTeaser;
